import React from "react";
import { useNavigate } from "react-router-dom";
import AccountHeader from "../../Component/Header/account_header";
import Footer from "../../Component/Footer";

function AboutUs() {
  const navigate = useNavigate();
  return (
    <div>
      <AccountHeader heading={'About Us'}></AccountHeader>
      <div id="appCapsule">
      <div className="macc-list p-15">
          <ul>
            <li onClick={() => navigate("/shipping-returns")}>
              <div className="macc-list-icon">
                <img src="/img/shipped.png" alt="Daadi's Kitchen" />
              </div>
              <div className="macc-list-content">
                <p className="mb-0 fw600"> Shipping & Returns</p>
              </div>
              <i className="ri-arrow-right-line"></i>
            </li>
            <li onClick={() => navigate("/about-us")}>
              <div className="macc-list-icon">
                <img src="/img/about.png" alt="Daadi's Kitchen" />
              </div>
              <div className="macc-list-content">
                <p className="mb-0 fw600">   About Us
                </p>

              </div>
              <i className="ri-arrow-right-line"></i>
            </li>
            <li onClick={() => navigate("/term-conditions")}>
              <div className="macc-list-icon">
                <img src="/img/terms.png" alt="Daadi's Kitchen" />
              </div>
              <div className="macc-list-content">
                <p className="mb-0 fw600"> Terms of Service</p>

              </div>
              <i className="ri-arrow-right-line"></i>
            </li>
            <li onClick={() => navigate("/faqs")}>
              <div className="macc-list-icon">
                <img src="/img/question.png" alt="Daadi's Kitchen" />
              </div>
              <div className="macc-list-content">
                <p className="mb-0 fw600">  Frequently Asked Questions</p>

              </div>
              <i className="ri-arrow-right-line"></i>
            </li>

            <li onClick={() => navigate("/privacy-policy")}>
              <div className="macc-list-icon">
                <img src="/img/insurance.png" alt="Daadi's Kitchen" />
              </div>
              <div className="macc-list-content">
                <p className="mb-0 fw600"> Privacy Policy</p>

              </div>
              <i className="ri-arrow-right-line"></i>
            </li>
            <li onClick={() => navigate("/contact-us")}>
              <div className="macc-list-icon">
                <img src="/img/phone.png" alt="Daadi's Kitchen" />
              </div>
              <div className="macc-list-content">
                <p className="mb-0 fw600"> Contact Us</p>

              </div>
              <i className="ri-arrow-right-line"></i>
            </li>
          </ul>
        </div>

      </div>

      <Footer />
    </div>
    
  );
}

export default AboutUs;
